/*

statistics implements mappers for each specialty

mappers are Objects

{
  columns: Array of component.id
    The choices that the user has to group the logs by columns
    The usual choice is Autonomy, or Surgery-Autonomy, but we may develop more as they become relevant
  
  rows: Object {
    key (component.id) : {
      options: () => (array of options [{text: '', value: ''}])
      checker: (log, componentId, option)=> bool         function that checks if the log belongs in that row
    }
  }

}

*/

import { LogMapper } from './mappers/base'
import { GeneralSurgeryMapper } from './mappers/generalSurgery'
import { AnesthesiologyMapper } from './mappers/anesthesiology'

LogMapper.registerMapper(GeneralSurgeryMapper)
LogMapper.registerMapper(AnesthesiologyMapper)

export default LogMapper.registeredMappers